
import Andriodiosservice from '../../components/solutions/andriodiosservice';
import Itsolution from '../../components/solutions/itsolution';
// import Solutionscontent from './solutionscontent';
import Solutionsachivement from '../../components/solutions/solutionsachivement';
import Head from 'next/head';
import Problemssection from '../../components/solutions/problemssection';
import SolutionContentPage from '../../components/solutions/solutioncontentpage';

import Solutionscontent from '@/components/solutions/solutionscontent';
import ServiceBaner from '@/components/solutions/servicebaner';
import { useEffect } from 'react';
import { getGuestLogDetailsApi } from '@/components/action/easycampus';




export default function Solutions() {
  const pageMetaData = {
    pageTitle: 'Solutions : Easycampus Solutions page',
    pageDescription: 'World',
  };

  useEffect(() => {
    handleGestLogUserData();
  }, []);

  const handleGestLogUserData = async () => {
    try {
      let data = {
        pageName:"Solutions"
      }

      const res = await getGuestLogDetailsApi(data);
      return;
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
       <Head>
      <title>One Stop Virtual Campus Placement Solution</title>
      <meta property="og:type" content="website"/>
      <meta name="description" content={" Easy Campus is a software solution, eliminates your Virtual Campus Hiring challenges, streamline the campus hiring process to stay competitive and ahead of the curve. "}/>
     <meta property="og:title" content={" Easy Campus is a software solution, eliminates your Virtual Campus Hiring challenges, streamline the campus hiring process to stay competitive and ahead of the curve. "}/>
      <meta name="description" content={" Easy Campus is a software solution, eliminates your Virtual Campus Hiring challenges, streamline the campus hiring process to stay competitive and ahead of the curve. "}/>
      <meta name="keywords" content={"Easycampus"}/>
      <meta property="og:url" content={"www.easycampus.in"}/>
      <meta property="og:description" content={" Easy Campus is a software solution, eliminates your Virtual Campus Hiring challenges, streamline the campus hiring process to stay competitive and ahead of the curve. "}/>
      <meta property="og:image" content={'https://ec-images.s3.ap-south-1.amazonaws.com/easycampus-logo-for-video.png'}/>
    </Head> 
        <main className="flex min-h-screen flex-col">
          <div className="w-full">
           <ServiceBaner/>
           <Problemssection/>
           <SolutionContentPage/>
           <Itsolution/>
           <Solutionscontent/>
           <Solutionsachivement/>
           <Andriodiosservice/>
          </div>
        </main>
    </>
  );
}
